import { useContext } from 'react'
import FormControlLabel from '@mui/material/FormControlLabel'
import MuiSwitch from 'frame/components/switch'
import { FormContext } from '../form'
import PropTypes from 'prop-types'

export const AdditionalServicesForm = ({ name, label, disabled }) => {
  const formContext = useContext(FormContext)
  const { values, onSwitchChange } = formContext

  return (
    <FormControlLabel
      control={
        <MuiSwitch
          name={name}
          checked={Boolean(values[name]) || false}
          onChange={onSwitchChange(name)}
          disabled={disabled}/>
      }
      label={label}/>
  )
}

AdditionalServicesForm.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  disabled: PropTypes.bool.isRequired,
  onSwitchChange: PropTypes.func.isRequired,
}
